import axios from '../config/api'

const state = () => ({
  data: [],
  paymentId: null,
  payload: null,
  isError: false,
  isLoading: false,
})

// getters
const getters = {
  getPaymentTypeById: state => id => {
    return state.data?.find(i => i?.id === id) ?? null
  },

  getCurrentPaymentType: state => {
    return state.data?.find(i => i?.id === state.paymentId) ?? null
  },
}

// actions
const actions = {
  async getPaymentType({ commit }, id) {
    //  if (state.data.length === 0) {
    try {
      const response = await axios.get(
        `/v2/payment-types/?campaign_id=${id}`,
      )
      commit('setPaymentTypeSuccess', response.data.data)
    } catch {
      commit('setPaymentTypeError')
    }
    // }
  },
}

// mutations
const mutations = {
  setPaymentId(state, payload) {
    state.paymentId = payload
  },
  setPaymentType(state) {
    state.isLoading = true
    state.isError = false
  },
  setPaymentTypeSuccess(state, payload) {
    state.isLoading = false
    state.data = payload
    state.isError = false
  },
  setPaymentTypeError(state) {
    state.isLoading = false
    state.isError = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
